var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fullscreen-modal',{attrs:{"id":"ContentExportOverlay"},on:{"open":_vm.onOverlayOpen,"close":_vm.onOverlayClose}},[_c('template',{slot:"header"},[_c('step-indicator',{attrs:{"steps":_vm.steps,"step-index":_vm.stepIndex}})],1),_vm._v(" "),_c(_vm.currentStep,{tag:"component"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ffa4846","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/ContentExportOverlay.vue
// module id = null
// module chunks = 